// Auto-generado desde "Cortinas de Enrollar.xlsx".
// Productos que pertenecen a la categoria "Cortinas de Enrollar" (van con el operario, junto a perfiles).
export const CORTINAS_ENROLLAR = new Set(["617111171", "617111353", "617111374", "617111375", "617111416", "617111417", "617111424", "617111582", "617116078", "617116080", "617311001", "617311067", "617313034", "617314008", "657313033", "671112863", "671112864", "671113603", "671113604", "671118663", "671118664", "671153433", "671153434", "671153453", "671153454", "671311055", "673120483", "673120484", "673330333", "673330334", "673330353", "673330354", "681054005", "70020032", "70020034", "70040254", "70060021", "671112333", "671112334", "671160433", "671183020", "671183021", "671183031", "671183038", "671183041", "671183044", "671183045", "681014575", "613140124", "657313034"]);

// Parte A (perfiles/cortinas). Los KITS van en su propia parte (K), no acá.
export const CAT_OPERARIO = ["PERFIL ALUMINIO", "PERFILES ALUMINIO", "CORTINAS DE ENROLLAR"];

// Dentro de "Cortinas de enrollar" separamos: los PERFILES (esta lista) van a la
// parte A (Perfiles/Cortinas, cualquiera los prepara); el RESTO de las cortinas
// son ACCESORIOS de cortinas → parte ACO (solo Encargado/Francisco y Hansel).
export const PERFILES_CORTINAS = new Set(["617333185", "673330333", "673330334", "673330353", "673330354", "617314008", "67312048", "673120483", "673120484", "617313034", "657313033", "617311001", "613140124", "657313034"]);

// Productos que NO deben tratarse como Kit (aunque el nombre diga "kit").
export const NO_KIT = new Set(["501900001"]); // Kit Americana

// ── Cerraduras PREMIUM: "kits" con componentes FIJOS/predefinidos ──
// No se vinculan a otro pedido (los componentes ya están definidos acá). Se
// clasifican en la categoría ACCESORIOS DE ALUMINIO (parte ACC). Los componentes
// se muestran con su NOMBRE (resuelto del catálogo por código) al preparar/controlar.
export const KITS_PREDEFINIDOS = {
  "661000110": [ // Cerradura PREMIUM Blanca C/Bisagras silver
    { cod: "661050004", cant: 1 }, { cod: "653000030", cant: 3 }, { cod: "661000131", cant: 1 },
  ],
  "661000111": [ // Cerradura PREMIUM Blanca
    { cod: "661050004", cant: 1 }, { cod: "661000131", cant: 1 },
  ],
  "661000112": [ // Cerradura PREMIUM Blanca C/Bisagras Blanco
    { cod: "653000010", cant: 3 }, { cod: "661050004", cant: 1 }, { cod: "661000131", cant: 1 },
  ],
  "661000120": [ // Cerradura PREMIUM Negra C/Bisagras Silver
    { cod: "661050003", cant: 1 }, { cod: "653000030", cant: 3 }, { cod: "661000131", cant: 1 },
  ],
  "661000121": [ // Cerradura PREMIUM Negra
    { cod: "661050003", cant: 1 }, { cod: "661000131", cant: 1 },
  ],
  "661000122": [ // Cerradura PREMIUM Negra C/Bisagras NEGRAS
    { cod: "653000020", cant: 3 }, { cod: "661050003", cant: 1 }, { cod: "661000131", cant: 1 },
  ],
  "502000020": [ // Kit Accesorios Serie 20 Corredizas x 25
    { cod: "669000030", cant: 100 }, // Rodamiento Serie 20
    { cod: "671000040", cant: 25 },  // Cierre Tecla Plastico Negro (Lara)
    { cod: "671000030", cant: 25 },  // Estanqueidad Serie 20/25 (par)
    { cod: "671000700", cant: 50 },  // Protector Desague Serie 20/25
    { cod: "671000070", cant: 100 }, // Tapón Serie 20
    { cod: "663070425", cant: 300 }, // Felpa Serie 20 7 X 4
    { cod: "671000050", cant: 25 },  // Tirador lat/embutir cubeta160 (par)
  ],
};

export function esKitPredefinido(codUru) {
  return Object.prototype.hasOwnProperty.call(KITS_PREDEFINIDOS, String(codUru));
}

// Componentes fijos de un kit predefinido (o null si no lo es).
export function componentesKitPredefinido(codUru) {
  return KITS_PREDEFINIDOS[String(codUru)] || null;
}

// Categoría efectiva de un producto (aplica el override de cortinas por sobre el catálogo).
export function categoriaEfectiva(codUru, doc) {
  if (CORTINAS_ENROLLAR.has(String(codUru))) return "CORTINAS DE ENROLLAR";
  const cat = String(doc?.categoria || "").toUpperCase().trim();
  const padre = String(doc?.padre || "").toUpperCase().trim();
  return (cat && cat !== "SIN_CATEGORIA") ? cat : padre;
}

// ¿El producto lo prepara el operario (Parte A: perfiles/cortinas)?
export function esParteOperario(codUru, doc) {
  return CAT_OPERARIO.includes(categoriaEfectiva(codUru, doc));
}

// Detecta si un producto es un KIT (por flag del catálogo o por el nombre "Kit ...").
export function esKitProducto(codUru, doc, item) {
  if (NO_KIT.has(String(codUru))) return false; // ej. Kit Americana: no se vincula
  if (esKitPredefinido(codUru)) return false;    // Cerraduras PREMIUM: kit fijo, no se vincula (va en ACC)
  if (doc?.esKitFinnegans === true || doc?.esKit === true || item?.esKit === true) return true;
  const nombre = String(doc?.customerNo || doc?.descripcion || item?.descripcion || item?.desc || item?.nombre || "").toLowerCase();
  return /\bkit\b/.test(nombre);
}

// Parte a la que pertenece un producto. Se clasifica por substring de la categoría
// efectiva (robusto a variantes de nombre en el catálogo):
//   A   = Perfiles de aluminio + Cortinas
//   ACC = Accesorios de aluminio
//   PVC = PVC (accesorios PVC + perfiles PVC)
//   VID = Vidrios
//   K   = Kits
//   B   = Resto / otros
export function parteDeProducto(codUru, doc, item) {
  // Cerraduras PREMIUM (kits fijos) → ACCESORIOS DE ALUMINIO, no la parte K.
  if (esKitPredefinido(codUru)) return "ACC";
  if (esKitProducto(codUru, doc, item)) return "K";
  const code = String(codUru);
  const cat = categoriaEfectiva(codUru, doc); // ya viene en MAYÚSCULAS
  // Cortinas de enrollar: los perfiles → A; los accesorios (resto) → ACO.
  const esCortina = CORTINAS_ENROLLAR.has(code) || PERFILES_CORTINAS.has(code) || cat.includes("CORTINA");
  if (esCortina) return PERFILES_CORTINAS.has(code) ? "A" : "ACO";
  if (cat.includes("VIDRIO")) return "VID";
  if (cat.includes("PVC")) return "PVC"; // incluye "ACCESORIO PVC" y "PERFILES PVC"
  if (cat.includes("ACCESORIO") && cat.includes("ALUMINIO")) return "ACC";
  if (esParteOperario(codUru, doc)) return "A"; // perfiles aluminio
  return "B";
}

// Código URU de un producto (mismo criterio que el resto de la app).
function _uruDe(it) {
  const raw = it?.cod || it?.codigo || it?.codigoURU || it?.desc || it?.descripcion || it?.nombre || "";
  const s = String(raw).trim();
  const m = s.match(/\b\d{7,}\b/);
  return m ? m[0] : s.split(/\s+/)[0].replace(/[^\w-]/g, "");
}

// ─── Expansión de kits vinculados ───────────────────────────────────────────
// Cuando un kit se vincula a su pedido de componentes, guardamos un snapshot de
// esos componentes en pedido.kitComponentes[codigoKit]. Esta función devuelve la
// lista de productos "efectiva": conserva la línea del kit como ENCABEZADO
// (marcada _kitHeader, que la categorización/preparación ignoran) e inserta debajo
// sus componentes (marcados _deKit / _kitNombre), para que se categoricen, asignen
// y preparen como productos normales. Los pedidos sin kits vinculados quedan igual.
// Es idempotente (no re-expande una lista ya expandida).
export function expandirProductosKit(pedido) {
  const productos = Array.isArray(pedido?.productos) ? pedido.productos : [];
  const snaps = pedido?.kitComponentes || null;
  if (!snaps || Object.keys(snaps).length === 0) return productos;
  if (productos.some(it => it && (it._kitHeader || it._deKit))) return productos;
  const out = [];
  for (const it of productos) {
    const uru = _uruDe(it);
    const snap = snaps[uru];
    const comps = snap && Array.isArray(snap.productos) ? snap.productos : null;
    if (comps && comps.length) {
      const kitNombre = snap.nombre || it.descripcion || it.desc || it.nombre || uru;
      out.push({ ...it, _kitHeader: uru, _kitNombre: kitNombre });
      for (const comp of comps) out.push({ ...comp, _deKit: uru, _kitNombre: kitNombre });
    } else {
      out.push(it);
    }
  }
  return out;
}

// ¿El producto es el encabezado de un kit expandido? (no se prepara; sus componentes sí)
export function esEncabezadoKit(it) {
  return !!(it && it._kitHeader);
}

// Set de partes que TIENEN al menos un producto (según la clasificación).
// Se usa para detectar categorías que quedaron vacías (p. ej. tras una corrección
// en Finnegans que eliminó el único producto de una categoría).
export function partesConProductos(productos, catalogoMap) {
  const set = new Set();
  for (const it of productos || []) {
    if (esEncabezadoKit(it)) continue; // el encabezado del kit no cuenta como parte
    const uru = _uruDe(it);
    set.add(parteDeProducto(uru, catalogoMap?.[uru], it));
  }
  return set;
}

// ¿El catálogo está cargado para TODOS los productos? (para clasificar con confianza
// antes de podar categorías vacías; si falta algún código, no se poda.)
export function catalogoCompletoPara(productos, catalogoMap) {
  if (!Array.isArray(productos) || productos.length === 0) return false;
  return productos.every(it => {
    if (esEncabezadoKit(it)) return true; // el encabezado no necesita catálogo
    const uru = _uruDe(it);
    return uru && catalogoMap && Object.prototype.hasOwnProperty.call(catalogoMap, uru) && catalogoMap[uru];
  });
}

// ¿El producto es CLASIFICABLE con confianza en una parte? true si tiene doc de
// catálogo real, o si un override lo clasifica SIN depender del catálogo (Cortinas
// de Enrollar, o kit predefinido). Un producto sin catálogo y sin override cae por
// defecto en "B" (Otros) → NO es confiable clasificarlo (puede cambiar cuando el
// catálogo se cargue). Esto es lo que causaba partes fantasma.
export function esProductoClasificable(codUru, doc) {
  if (doc) return true;
  const code = String(codUru);
  return CORTINAS_ENROLLAR.has(code) || esKitPredefinido(code);
}

// ¿Todos los productos del pedido son clasificables con confianza? Se usa para
// HABILITAR la asignación de responsables y para correr la auto-poda de partes
// vacías. A diferencia de `catalogoCompletoPara`, no exige que TODOS estén en el
// catálogo: acepta los cubiertos por override (que se clasifican bien igual).
export function catalogoListoPara(productos, catalogoMap) {
  if (!Array.isArray(productos) || productos.length === 0) return false;
  return productos.every(it => {
    if (esEncabezadoKit(it)) return true;
    const uru = _uruDe(it);
    return esProductoClasificable(uru, catalogoMap?.[uru]);
  });
}

// ¿El catálogo ya fue CONSULTADO para todos los productos? (la clave existe en el
// mapa, aunque el valor sea null porque el producto no está catalogado). A diferencia
// de catalogoListoPara, NO exige que todos sean clasificables: una vez terminada la
// consulta, los que no tienen catálogo se clasifican como "Otros" (B) — que es lo que
// hace parteDeProducto por defecto. Se usa para HABILITAR la asignación y la auto-poda
// una vez que el catálogo terminó de cargar, sin bloquear por códigos sin catálogo.
export function catalogoFetchedPara(productos, catalogoMap) {
  if (!Array.isArray(productos) || productos.length === 0) return false;
  return productos.every(it => {
    if (esEncabezadoKit(it)) return true;
    const uru = _uruDe(it);
    return uru && catalogoMap && Object.prototype.hasOwnProperty.call(catalogoMap, uru);
  });
}

// Códigos del pedido que NO están en el catálogo y ningún override los cubre → hay
// que cargarlos al catálogo para poder clasificarlos. (Para avisar al usuario.)
export function codigosSinCatalogo(productos, catalogoMap) {
  const out = [];
  for (const it of (productos || [])) {
    if (esEncabezadoKit(it)) continue;
    const uru = _uruDe(it);
    if (!esProductoClasificable(uru, catalogoMap?.[uru])) out.push(uru);
  }
  return [...new Set(out)];
}

// Etiquetas legibles de cada parte.
export const PARTE_LABEL = {
  A: "Perfiles / Cortinas",
  ACC: "Accesorios de Aluminio",
  ACO: "Accesorios de Cortinas",
  PVC: "PVC",
  VID: "Vidrios",
  K: "Kits",
  B: "Otros",
};

// Orden en que se muestran las partes en la UI.
export const PARTE_ORDER = ["A", "ACC", "ACO", "PVC", "VID", "K", "B"];

// Reglas de quién puede ser responsable de cada parte:
//   elegibles: null = cualquiera; array de nombres = solo esos (match por nombre).
//   preferido: nombre preseleccionado por defecto (o null).
export const REGLAS_PARTE = {
  A:   { elegibles: null, preferido: null },
  ACC: { elegibles: ["Hansel", "Francisco"], preferido: "Hansel" },
  ACO: { elegibles: ["Hansel", "Francisco"], preferido: "Hansel" }, // accesorios de cortinas
  PVC: { elegibles: ["Hansel", "Francisco", "Luis"], preferido: "Luis" },
  VID: { elegibles: ["Hansel", "Francisco", "Luis"], preferido: "Hansel" },
  K:   { elegibles: null, preferido: null },
  B:   { elegibles: null, preferido: null },
};

function nombreCoincide(nombreOperario, target) {
  return String(nombreOperario || "").toLowerCase().includes(String(target || "").toLowerCase());
}

// Operarios elegibles para una parte (según REGLAS_PARTE, match por nombre).
export function operariosElegiblesParte(parte, operarios) {
  const regla = REGLAS_PARTE[parte];
  if (!regla || !regla.elegibles) return operarios || [];
  return (operarios || []).filter((op) =>
    regla.elegibles.some((nom) => nombreCoincide(op.nombre || op.displayName, nom))
  );
}

// Operario preseleccionado por defecto para una parte (o null).
export function operarioPreferidoParte(parte, operarios) {
  const regla = REGLAS_PARTE[parte];
  if (!regla || !regla.preferido) return null;
  return (operarios || []).find((op) => nombreCoincide(op.nombre || op.displayName, regla.preferido)) || null;
}
